import router from './router';
import * as routerActions from './routerActions';

export default router;
export {routerActions};
